export default {
  getOfferingVehicleAssetsForInvestor(state) {
    return state.offerings.singleOffer.vehicle.project.assets;
  },
}
